import { cn } from "@/lib/utils";
import { type HTMLAttributes } from "react";

type ListingItemAttributesProps = HTMLAttributes<HTMLDivElement> & {
  label?: string;
  children: React.ReactNode;
  classNameChildren?: string;
};

export const ListingItemAttributes = ({
  label,
  children,
  classNameChildren,
  ...props
}: ListingItemAttributesProps) => {
  return (
    <div {...props}>
      {label && (
        <p className="mb-0.5 text-[11px] font-bold uppercase text-black/50">
          {label}
        </p>
      )}
      <div className={cn("text-base leading-6", classNameChildren)}>
        {children}
      </div>
    </div>
  );
};
